exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-checkbox[data-v-0d8a1f54]{height:1.2rem;width:1.2rem}", ""]);

// exports
